import React, { useContext } from 'react'
import {
  Switch,
  Route
} from 'react-router-dom';

// styles
import "./MainContent.css";
// pages
import Login from '../../pages/authentication/Login/Login.page';
import Logout from '../../pages/authentication/Logout/Logout.page';
// ---- Jobs
import JobList from '../../pages/job/JobList/JobList.page';
import JobDetail from '../../pages/job/JobDetail/JobDetail.page';
// ---- Schedule
import Schedule from '../../pages/jobDay/Schedule/Schedule.page';
import JobDayDetail from '../../pages/jobDay/JobDayDetail/JobDayDetail.page';
import GenerateTimeTicketPDF from '../../pages/jobDay/GenerateTimeTicketPDF/GenerateTimeTicketPDF.page';
// ---- Crew
import CrewList from '../../pages/crewMember/CrewList/CrewList.page';
import CrewDetail from '../../pages/crewMember/CrewDetail/CrewDetail.page';
// ---- Inventory
import Inventory from '../../pages/inventory/InventoryDashboard/InventoryDashboard.page';
import EquipmentList from '../../pages/equipment/EquipmentList/EquipmentList.page';
import EquipmentDetail from '../../pages/equipment/EquipmentDetail/EquipmentDetail.page';
import EquipmentRequestList from '../../pages/equipmentRequest/EquipmentRequestList/EquipmentRequestList.page';
import EquipmentRequestPDF from '../../pages/equipmentRequest/EquipmentRequestPDF/EquipmentRequestPDF.page';
import EquipmentRequestDetail from '../../pages/equipmentRequest/EquipmentRequestDetail/EquipmentRequestDetail.page';
import PurchaseOrderList from '../../pages/purchaseOrder/PurchaseOrderList/PurchaseOrderList.page';
import PurchaseOrderDetail from '../../pages/purchaseOrder/PurchaseOrderDetail/PurchaseOrderDetail.page';

// wrappers
import ProtectedRoute from '../../wrappers/permissions/ProtectedRoute/ProtectedRoute.wrapper';

// contexts
import { AuthenticationContext } from '../../contexts/authentication';

const MainContent = () => {
  const authentication = useContext(AuthenticationContext)
  
  // routes
  let routes = null;

  if(authentication.isLoggedIn) {
    routes = (
      <React.Fragment>
        <Route exact path='/jobs' render={(props) => <ProtectedRoute groupsAllowed={['Admin']} component={JobList} {...props} />} />
        <Route exact path='/jobs/:jobId' render={(props) => <ProtectedRoute groupsAllowed={['Admin']} component={JobDetail}  {...props} />} />

        <Route exact path='/schedule' render={(props) => <ProtectedRoute groupsAllowed={['Admin', 'ForemanWithLimitedAdminAccess', 'ScheduleReadOnly']} component={Schedule}  {...props} />} />
        <Route exact path='/schedule/:startDateString' render={(props) => <ProtectedRoute groupsAllowed={['Admin', 'ForemanWithLimitedAdminAccess', 'ScheduleReadOnly']} component={Schedule}  {...props} />} />
        <Route exact path='/schedule/jobDay/:jobDayId' render={(props) => <ProtectedRoute groupsAllowed={['Admin', 'ForemanWithLimitedAdminAccess', 'ScheduleReadOnly']} component={JobDayDetail}  {...props} />} />
        <Route exact path='/schedule/jobDay/:jobDayId/generate-time-ticket-pdf' render={(props) => <ProtectedRoute groupsAllowed={['Admin']} component={GenerateTimeTicketPDF}  {...props} />} />
        <Route exact path='/crew' render={(props) => <ProtectedRoute groupsAllowed={['Admin']} component={CrewList}  {...props} />} />
        <Route exact path='/crew/:crewMemberId' render={(props) => <ProtectedRoute groupsAllowed={['Admin']} component={CrewDetail}  {...props} />} />

        <Route exact path='/inventory' render={(props) => <ProtectedRoute groupsAllowed={['Admin', 'EquipmentRequestReadOnly', 'ReceivingLimitedAccess']} component={Inventory}  {...props} />} />
        <Route exact path='/inventory/equipment' render={(props) => <ProtectedRoute groupsAllowed={['Admin', 'EquipmentRequestReadOnly', 'ReceivingLimitedAccess']} component={EquipmentList} {...props} />} />
        <Route exact path='/inventory/equipment/:equipmentId' render={(props) => <ProtectedRoute groupsAllowed={['Admin', 'ReceivingLimitedAccess']} component={EquipmentDetail}  {...props} />} />
        <Route exact path='/inventory/equipment-requests' render={(props) => <ProtectedRoute groupsAllowed={['Admin', 'EquipmentRequestReadOnly']} component={EquipmentRequestList}  {...props} />} />
        <Route exact path='/inventory/equipment-request/:requestId/generate-pdf' render={(props) => <ProtectedRoute groupsAllowed={['Admin', 'ForemanWithLimitedAccess', 'EquipmentRequestReadOnly']} component={EquipmentRequestPDF} {...props} />} />
        <Route exact path='/inventory/equipment-requests/:requestId' render={(props) => <ProtectedRoute groupsAllowed={['Admin', 'EquipmentRequestReadOnly']} component={EquipmentRequestDetail}  {...props} />} />

        <Route exact path='/inventory/purchase-orders' render={(props) => <ProtectedRoute groupsAllowed={['Admin']} component={PurchaseOrderList}  {...props} />} />
        <Route exact path='/inventory/purchase-orders/:orderId' render={(props) => <ProtectedRoute groupsAllowed={['Admin']} component={PurchaseOrderDetail}  {...props} />} />

        <Route exact path='/logout' render={(props) => <Logout  {...props} /> } />
      </React.Fragment>
    )
  } else {
    routes = (
      <React.Fragment>
        <Route path='/' render={(props) => <Login {...props} />} /> 
      </React.Fragment>
    )
  }

  return (
    <div className="main-content">
      <Switch>{routes}</Switch>
    </div>
  )
}

export default MainContent
